<template>
  <div id="app">
    <div class="container outter">
      <router-link :to="'/'">
        <div class="top-tag center-block"><h2>DISCOVER THE DECO DIFFERENCE</h2></div>
        <div class="corner-logo">
        <img :src="'static/img/corner-red.png'"  width="70" class="img-responsive">
        </div>
        </router-link>
        <transition name="fade">
    <router-view/>
        </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
@import 'styles/styles.css';
@import './../static/bootstrap/css/bootstrap.min.css';

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue